import React, {FC} from 'react'
import './shops-page.less'
import {ShopGard} from "./shop-card";
import {ShopTypes} from "../../../bll/types";
import {NavLink} from 'react-router-dom';

type PropsType = {
    shops: ShopTypes[]
}

export const ShopsPage: FC<PropsType> = ({shops}) => {
    return <div>
        <div className="muztorg">
            <div className="main-caption-of-shop">
                <div className="strips-menu">
                    <div className='block-name'>
                        ПРОДАЖА МУЗЫКАЛЬНОГО ОБОРУДОВАНИЯ
                    </div>
                    <div className='block-name-link'>
                        <a href=''>МАГАЗИНЫ</a>
                    </div>
                    <div className="container  caption">
                        ПОЛУЧАЙ <span className="color-text">БОНУСЫ </span> ЗА ПОКУПКУ ОБОРУДОВАНИЯ У НАШИХ ПАРТНЁРОВ.
                        <p>
                            ОЗНАКОМЬСЯ С ИНСТРУКЦИЕЙ НИЖЕ ЧТОБЫ УЗНАТЬ, КАК ЭТО РАБОТАЕТ.
                        </p>
                    </div>
                </div>
            </div>
            <div className="steps-of-shoping">
                <div className="container">
                    <div className="row">
                        <div className="step col-xl-4">
                            <h2 className='color-text'>ШАГ 1</h2>
                            <div className='description'>
                                Перейди на страницу твоего любимого магазина с музыкальным оборудованием и получи
                                специальный купон от beatmaker.tv

                            </div>
                            <a href="https://beatmaker.tv/help/magaziny_partnyory" className="color-text"
                               target={'_blank'}
                               rel="noreferrer">
                                Подробнее...
                            </a>
                        </div>
                        <div className="step col-xl-4">
                            <h2 className='color-text'>ШАГ 2</h2>
                            <div className='description'>
                                Посети выбраную торговую точку и соверши покупку, сообщив продавцу купон и попросив
                                активировать его.
                            </div>
                            <a href="https://beatmaker.tv/help/magaziny_partnyory" className="color-text"
                               target={'_blank'}
                               rel="noreferrer">
                                Подробнее...
                            </a>
                        </div>
                        <div className="step col-xl-4">
                            <h2 className='color-text'>ШАГ 3</h2>
                            <div className='description'>
                                Получи обратно 20% стоимости купленного тобой оборудования в виде монет, дней подписки и
                                так далее.
                            </div>
                            <a href="https://beatmaker.tv/help/magaziny_partnyory" className="color-text"
                               target={'_blank'}
                               rel="noreferrer">
                                Подробнее...
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="list-of-shop">
                {shops.map(shop => <NavLink to={`/shops/${shop.id}`} style={{color: 'black'}}><ShopGard
                    shop={shop}/></NavLink>)}
            </div>
        </div>
    </div>
}